import lager_926 from './funnels/lager_926';
import lackierer from './funnels/lackierer';
import hermes_915 from './funnels/hermes_915';
import thoni_915 from './funnels/thoni_915';
import lenze_918 from './funnels/lenze_918';
import mecha_927 from './funnels/mecha_927';
import labor_927 from './funnels/labor_927';
import auto_elek_1019 from './funnels/auto_elek_1019';

const FUNNEL_CONFIGS = { lager_926, lackierer, hermes_915, thoni_915, lenze_918, mecha_927, labor_927, auto_elek_1019 };

export default FUNNEL_CONFIGS;
